import { useState } from "react"
import { useGetResultsBibNameSearchQuery } from "../../api/reigniteApi"
import useDebounce from "../../hooks/useDebounce"
import { TypeAhead } from '../shared/TypeAhead'
import { styles } from './styles';
import { TypeaheadOption } from "./TypeaheadOption"
import { withTranslation } from "react-i18next"
import {EventMetadataState} from '../../model/eventResultsState'
import { SearchIconNew } from '../../components/shared/icons';

type Props = {
  eventId: number
  eventMetadata: typeof EventMetadataState
  ignorePrivacySettings?: boolean
  isMobile: boolean
  masterEventId: number
  t: (value: string) => string
}

const EventResultsBibNameSearch = ({
  eventId,
  eventMetadata,
  ignorePrivacySettings = true,
  isMobile,
  masterEventId,
  t,
}: Props) => {
  const [term, setTerm] = useState('')
  const debounce = useDebounce(term, 1000)
  const { data, error, isLoading, refetch } = useGetResultsBibNameSearchQuery({
    eventId,
    from: 0,
    limit: 20,
    term: debounce,
  }, {
    skip: !debounce,
  })

  const flattenedResults = data?.map(result => ({
    ...result,
    eventId,
    masterEventId
  })).filter(x => {
    // filter results that can't resolve to a result page or athlete race page
    return (!!x.azpEntryId || !!x.azpTeamEntryId) || !!x.entryId || !!x.bib
  }) || []

  return (
    <span>
      <TypeAhead
        InputIcon={() => <SearchIconNew />}
        inputProps={{
          id: 'event-results-search',
          fullWidth: true,
        }}
        useMaterialUi
        value={term}
        placeholder={
          isMobile ? t('Search by name or bib') : t('Search by name or bib number')
        }
        dropdownHeight={300}
        dropdownTop={35}
        hideDropdownOverride={!term}
        options={term ? flattenedResults : []}
        dropdownStyle={styles.typeaheadDropDown}
        renderOption={(props: any) => <TypeaheadOption
          ignorePrivacySettings={ignorePrivacySettings}
          eventMetadata={eventMetadata?.data}
          {...props}
        />}
        onChange={(e: { target: { value: string } }) => {
          setTerm(e.target.value)
        }}
        onOptionSelected={() => { }}
        searching={isLoading}
        errorMessage={error}
        retrySearch={() => refetch()}
        width={isMobile ? '85%' : '100%'}
      />
    </span>
  );
}

export default withTranslation()(EventResultsBibNameSearch)